module.exports = __webpack_public_path__ + "img/logo_cadooz.450fc122.svg";